import { Container } from "react-bootstrap";
import React from "react";

export const Education = () => {
    return (
        <section className="education-section" id="education">
            <Container>
                <h2 className="section-title text-center">Education</h2>
                <div className="education-card mt-5">
                    <div className="education-header">
                        <div>
                            <h3>Cornell University</h3>
                            <h5 className="education-degree">Bachelor of Science in Computer Science</h5>
                        </div>
                        <div className="education-dates text-md-end">
                            <p>Expected December 2026</p>
                        </div>
                    </div>
                    <div className="education-body mt-3">
                        <p><strong>Relevant Coursework:</strong> Algorithms, Data Structures, Operating Systems, Computer System Organization and Programming, Object-Oriented Programming, Functional Programming, Machine Learning, Artificial Intelligence, Data Science</p>
                        <p><strong>Organizations:</strong> Cornell University Unmanned Air Systems</p>
                    </div>
                </div>
            </Container>
        </section>
    );
}
